import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { stakeholderHistory as stakeholdersHistorySchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectEntities } from './entities.js';

// API Actions

// History API Actions
const RETRIEVE_STAKEHOLDERS_HISTORY_REQUEST =
  'changesync/stakeholdersHistory/RETRIEVE_STAKEHOLDERS_HISTORY_REQUEST';
const RETRIEVE_STAKEHOLDERS_HISTORY_SUCCESS =
  'changesync/stakeholdersHistory/RETRIEVE_STAKEHOLDERS_HISTORY_SUCCESS';
const RETRIEVE_STAKEHOLDERS_HISTORY_FAILURE =
  'changesync/stakeholdersHistory/RETRIEVE_STAKEHOLDERS_HISTORY_FAILURE';
const RETRIEVE_STAKEHOLDER_HISTORY_REQUEST =
  'changesync/projectStakeholdersHistory/RETRIEVE_STAKEHOLDER_HISTORY_REQUEST';
const RETRIEVE_STAKEHOLDER_HISTORY_SUCCESS =
  'changesync/projectStakeholdersHistory/RETRIEVE_STAKEHOLDER_HISTORY_SUCCESS';
const RETRIEVE_STAKEHOLDER_HISTORY_FAILURE =
  'changesync/projectStakeholdersHistory/RETRIEVE_STAKEHOLDER_HISTORY_FAILURE';

// Initial State

const initialState = {
  /**
   * @property {object} historyIds
   * Arrays of history IDs indexed by project ID
   * @example
   * {
   *   [projectId]: [historyId, historyId, ...]
   * }
   */

  stakeholdersHistory: {
    historyIds: {},
    pending: false,
    success: false,
    error: null,
  },

  stakeholderHistory: {
    historyIds: {},
    pending: false,
    success: false,
    error: null,
  },
};

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_STAKEHOLDERS_HISTORY_REQUEST:
      return {
        ...state,
        stakeholdersHistory: {
          ...state.stakeholdersHistory,
          pending: true,
          success: false,
          error: null,
        },
      };

    case RETRIEVE_STAKEHOLDERS_HISTORY_SUCCESS:
      return {
        ...state,
        stakeholdersHistory: {
          historyIds: {
            [action.meta.projectId]: action.payload.result,
          },
          pending: false,
          success: true,
        },
      };

    case RETRIEVE_STAKEHOLDER_HISTORY_REQUEST:
      return {
        ...state,
        stakeholdersHistory: {
          ...state.stakeholderHistory,
          pending: true,
          success: false,
          error: null,
        },
      };

    case RETRIEVE_STAKEHOLDER_HISTORY_SUCCESS:
      return {
        ...state,
        stakeholderHistory: {
          ...state.stakeholderHistory,
          historyIds: {
            [action.meta.projectId]: action.payload.result,
          },
          pending: false,
          success: true,
        },
      };

    default:
      return state;
  }
};

// Action Creators

export const retrieveStakeholdersHistory = (projectId) => (dispatch) => {
  const url = `projects/${projectId}/stakeholders/stakeholders_and_project_histories`;
  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_STAKEHOLDERS_HISTORY_REQUEST,
        RETRIEVE_STAKEHOLDERS_HISTORY_SUCCESS,
        RETRIEVE_STAKEHOLDERS_HISTORY_FAILURE,
      ],
      endpoint: url,
      method: HTTP_METHODS.GET,
      schema: [stakeholdersHistorySchema],
      disabledCamelizeKeys: true,
    },
    meta: {
      projectId,
    },
  });
};

export const retrieveStakeholderHistory =
  (projectId, stakeholderId) => (dispatch) => {
    const url = `projects/${projectId}/stakeholders/stakeholders_and_project_histories?stakeholder_id=${stakeholderId}`;
    return dispatch({
      [CALL_API]: {
        types: [
          RETRIEVE_STAKEHOLDER_HISTORY_REQUEST,
          RETRIEVE_STAKEHOLDER_HISTORY_SUCCESS,
          RETRIEVE_STAKEHOLDER_HISTORY_FAILURE,
        ],
        endpoint: url,
        method: HTTP_METHODS.GET,
        schema: [stakeholdersHistorySchema],
        disabledCamelizeKeys: true,
      },
      meta: {
        projectId,
      },
    });
  };

// Selectors

// For all stakeholders
const selectStakeholdersHistoryIds = (state, props) =>
  state.stakeholdersHistory.stakeholdersHistory.historyIds[props.projectId];
//
export const selectStakeholdersHistory = createSelector(
  selectStakeholdersHistoryIds,
  selectEntities,
  (historyIds, entities) =>
    denormalize(historyIds, [stakeholdersHistorySchema], entities)
);

// For single stakeholder
const selectStakeholderHistoryIds = (state, props) =>
  state.stakeholdersHistory.stakeholderHistory.historyIds[props.projectId];

export const selectStakeholderHistory = createSelector(
  selectStakeholderHistoryIds,
  selectEntities,
  (historyIds, entities) =>
    denormalize(historyIds, [stakeholdersHistorySchema], entities)
);
